import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CONSENT_KEY, getConsent, saveConsent } from "../lib/consent";

export const useConsent = () => {
  const [open, setOpen] = useState(() => getConsent() === null);
  useEffect(() => {
    const reopen = () => setOpen(true);
    const synchronize = (event) => {
      if (event.key === CONSENT_KEY || event.key === null) setOpen(getConsent() === null);
    };
    window.addEventListener("we-open-cookies", reopen);
    window.addEventListener("storage", synchronize);
    return () => {
      window.removeEventListener("we-open-cookies", reopen);
      window.removeEventListener("storage", synchronize);
    };
  }, []);

  const decide = (value) => {
    if (!saveConsent(value)) {
      toast.warning(<span data-testid="cookie-storage-warning">No se pudo guardar tu preferencia. Se aplicará durante esta visita.</span>, { id: "cookie-storage-warning" });
    }
    setOpen(false);
  };
  return { open, decide };
};